export const supplies = {
	pageTitle: "Insumos",
	pageDescription:
		"Insumos son todos los materiales que se utilizan para la producción de determinado producto o en la creación de otro insumo. En esta pantalla es posible registrar y visualizar todos los insumos registrados en un lugar.",
	searchPlaceholder: "Buscar insumos",
	formErrors: {
		supplyName: "Nombre del insumo debe ser llenado",
		conversionRule: "Los valores de la regla de conversión deben ser llenados",
		productRulesNotValidCount: "El valor de pérdida no puede ser mayor que la cantidad",
	},
	table: {
		name: "Nombre",
		productionRule: "Recetas y producción",
		conversionRule: "Regla de conversión",
		hasProductionRule: "¿Tiene ficha técnica?",
		actions: "Acciones",
		clickToEdit: "Haga clic para editar",
		sku: "SKU",
		yieldPercentage: "Rendimiento",
		links: "Productos e insumos Vinc.",
		stocks: "Inventarios",
	},
	supplyActionModal: {
		title: {
			supply: "Vínculos del insumo",
			stock: "Vínculos del inventario",
		},
		description: {
			supply: "Relación de registro con los cuales este elemento está vinculado",
			stock: "Relación de inventarios donde el producto está presente",
		},
		seeProductButton: "Ver producto",
		seeStockButton: "Ver inventario",
	},
	deleteWarning: "¿Está seguro que desea eliminar este elemento?",
	addSupplies: "Agregar insumo",
	editSupplies: "Editar insumo",
	importSupplies: "Importar insumos",
	exportToExcel: "Exportar a Excel",
	addSuppliesModal: {
		name: "Nombre",
		unitMeasure: "Unidad de Medida",
		units: "Unidades",
		errorMessage: "Este campo es obligatorio",
		yieldPercentage: "Rendimiento",
	},
	suppliesErrorsTableColumns: {
		supply: "Insumo",
		error: "Error",
	},
	importModal: {
		title: "Importar insumo",
		sheetFileName: "Insumos",
		conclude: "Concluir",
		buttonText: "Elija una hoja de cálculo",
	},
	step: {
		supply: "Insumo",
		ingredients: "Ingredientes",
	},
	addInputModal: {
		title: "Agregar insumo",
		supply: "Insumo o producto",
		name: "Nombre",
		placeholderName: "Ingrese el nombre del insumo",
		sku: "SKU",
		placeholderSKU: "Ingrese el SKU",
		image: "Foto",
		descriptionImage: "Imagen cuadrada o 500x500 píxeles",
		yieldPercentage: "Rendimiento",
		basicStorageUnit: "Inventario controlado por",
		placeholderBasicStorageUnit: "Ingrese la unidad de medida",
		aboutIngredients: "Sobre ingredientes",
		ingredientsInfo:
			"Llene los campos de ingredientes solo si el producto es una receta que utiliza otros insumos. Por ejemplo, salsa de tomate necesita ingredientes, pero tomate no.",
		selectInput: "Seleccione un insumo o producto",
		quantity: "Cantidad",
		loss: "Pérdida",
		addIngredient: "Agregar ingrediente",
	},
	productRule: {
		title: "Ficha técnica - {{productName}}",
		generatedQuantity: "Cantidad generada",
		tooltipMessage:
			"Para cambiar la cantidad generada es necesario eliminar la ficha técnica y crearla nuevamente.",
		form: {
			product: "Producto",
			quantity: "Cantidad",
			loss: "Pérdida",
		},
		addAnotherSupply: "Agregar otro insumo",
		hasProductionRuleError:
			"Atención, esta ficha técnica tiene un error. Elimine la ficha técnica y agréguela nuevamente.",
		warnings: {
			emptySupplies: "Seleccione un insumo",
			emptyQuantity: "Agregue la cantidad del insumo",
			repeatEntry: "Usted agregó insumos repetidos",
		},
		erros: { countLossInvalid: "El valor de pérdida no puede ser mayor que la cantidad" },
	},
	cancel: "Cancelar",
	conclude: "Concluir",
	erase: "Borrar",
	remove: "Eliminar",
	yes: "Sí",
	no: "No",
	yesCaps: "SÍ",
	noCaps: "NO",
	edit: "Editar",
	delete: "Eliminar",
	link: "Vínculo",
	links: "Vínculos",
	deleteSelectedSupplies: "Eliminar insumos seleccionados",
	deleteSelectedItens: "Eliminar elementos seleccionados",
	deleteSupply: "Eliminar insumo",
	deleteItems: "Eliminar elementos",
	importSupply: "Importar insumo",
	import: "Importar",
	confirmDeleteMessage: {
		multiple:
			"Al confirmar la acción usted elimina permanentemente {{quantity}} insumos. ¿Desea continuar?",
		single:
			"Al confirmar la acción usted elimina permanentemente el insumo {{supply}}. ¿Desea continuar?",
	},
	viewRules: "Ver recetas",
	viewConversionRule: "Ver regla",
	doesNotHave: "No posee",
	copiedSuccessfully: "Copiado con éxito",
	cannotDeleteSupply:
		"No es posible eliminar porque el insumo está vinculado a otros productos",
};
